import { merge } from 'lodash';
import { BaseClient as InfraBaseClient } from 'vue-infra';
import Config from '@config/config';
import BaseClient from '@core/common/BaseClient';
import { RESOURCES_CONFIGURATION_TIMEOUT as TIMEOUT } from '@config/Consts';

const EVENTS = BaseClient.EVENTS;

const RESOURCES = {
  METRICS: 'metrics',
  AGENT_VIEW: 'agentView',
  HISTORICAL: 'historical',
};

const METRICS_RESOURCE_PARAMS = {
  REQUEST_METRICS_TO_RETRIEVE_BY_TIME: {
    CLOSED: 'closed_conversations',
    AVG_WAIT_TIME: 'avg_wait_time',
    AVG_WAIT_TIME_FIRST_RESPONSE: 'avg_wait_time_first_response',
    AVG_TIME_TO_RESPONSE: 'avg_time_to_response',
    AVG_TIME_TO_FIRST_RESPONSE_FIRST_ASSIGNMENT: 'avg_time_to_first_response_first_assignment',
    TRANSFERS: 'transfers',
    CONCLUDED_CONVERSATIONS: 'concluded_conversations',
    CLOSED_BY_AGENT: 'closed_by_agent',
    CLOSED_BY_CONSUMER: 'closed_by_consumer',
    AUTO_CLOSED: 'auto_closed',
    AVG_CONVERSATIONS_DURATION: 'avg_conversations_duration',
  },
  REQUEST_METRICS_TO_RETRIEVE_CURRENT_VALUE: {
    ASSIGNED: 'assigned_conversations',
    HUMAN_AGENT_LOAD: 'human_agent_load',
    ONLINE_AGENTS: 'online_agents',
    AWAY_AGENTS: 'away_agents',
    BACK_SOON_AGENTS: 'back_soon_agents',
    HUMAN_ONLINE_LOAD: 'human_online_load',
    HUMAN_AWAY_LOAD: 'human_away_load',
    // Moved from reporting
    OVERDUE_IN_QUEUE: 'overdue_conversations_in_queue',
    UNASSIGNED: 'unassigned_conversations',
    WAIT_TIME_90: 'queue_wait_time_90th_percentile',
    WAIT_TIME_50: 'queue_wait_time_50th_percentile',
    // OVERDUE_CONVERSATIONS_IN_QUEUE: 'overdue_conversations_in_queue',
    // UNASSIGNED_CONVERSATIONS: 'unassigned_conversations',
    // QUEUE_WAIT_TIME_90: 'queue_wait_time_90th_percentile',
  },
  REQUEST_GROUP_BY: {
    AGENT_GROUP: 'agentGroupId',
    AGENT: 'agentId',
    SKILL: 'skillId',
  },
  RESPONSE_SECTIONS: {
    ALL: 'all',
    GROUP_BY: 'groupBy',
  },
};

const RESOURCES_CONFIGURATION = {
  [RESOURCES.METRICS]: {
    ALLOWED_METHODS: [BaseClient.HTTP_METHODS.POST],
    URL_KEY: () => 'AgentManagerData.Metrics',
    TIMEOUT: [TIMEOUT.GENERAL_RESOURCE],
  },
  [RESOURCES.AGENT_VIEW]: {
    ALLOWED_METHODS: [BaseClient.HTTP_METHODS.POST],
    URL_KEY: () => 'AgentManagerData.AgentView',
    TIMEOUT: [TIMEOUT.GENERAL_RESOURCE],
  },
  [RESOURCES.HISTORICAL]: {
    ALLOWED_METHODS: [BaseClient.HTTP_METHODS.POST],
    URL_KEY: () => 'AgentManagerData.Historical',
    TIMEOUT: [TIMEOUT.GENERAL_RESOURCE],
  },
};

function createInfraBaseClient(options, config) {
  const { baseURL, apiResource } = BaseClient.urlResolver.resolveUrl(RESOURCES_CONFIGURATION[config.resource]);
  const infraBaseClientOptions = {
    allowedMethods: RESOURCES_CONFIGURATION[config.resource].ALLOWED_METHODS,
    config: {
      baseURL,
      timeout: RESOURCES_CONFIGURATION[config.resource].TIMEOUT,
    },
    source: {
      appName: Config.moduleName,
      contextName: config.contextName,
    },
    body: {
      v: apiResource.version,
    },
    retryConfig: BaseClient.getClientRetryConfig,
  };
  merge(infraBaseClientOptions, options);
  return new InfraBaseClient(infraBaseClientOptions);
}

class AgentManagerClient extends BaseClient {
  /*
  @param options {resource, infraBaseClientConfig}
 */
  constructor({
    infraBaseClientOptions,
    ...options
  }) {
    const infraBaseClient = createInfraBaseClient(infraBaseClientOptions,
      options);
    super({
      name: 'AgentManagerClient',
      infraBaseClient,
      ...options,
    });
  }
}

AgentManagerClient.EVENTS = EVENTS;

export {
  RESOURCES,
  EVENTS,
  METRICS_RESOURCE_PARAMS,
  AgentManagerClient,
};

